import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const NOTE_PATH = 'note'

export function getPageNotes(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${NOTE_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function createOrUpdateNote(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${NOTE_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
